<template>
  <div>
    <div v-if="printRow.startStationName" id="print" style="display: none; padding: 0 6px;">
     <div style="width: 100%;text-align: center;font-size: 16px;font-weight: bold">神都出行</div>
     <div style="width: 100%;text-align: center;font-size: 14px">{{ printRow.organizationName }}</div>
     <div style="border-width: 8px;border-bottom: 1px dashed #333333;height: 1px;margin: 2px 0;"></div>
     <div style="font-size: 16px;margin-bottom: 4px">线路名称: {{ printRow.startStationName }}-{{ printRow.endStationName }}</div>
     
     <div style="width: 100%; margin-bottom: 4px;">
      <div style="width: 50%;font-size: 12px;display: inline-block;">
        <div style="margin-bottom: 4px;">票号: {{ printRow.ticketNo }}</div>
        <div style="margin-bottom: 4px;">售票: {{printRow.ticketSeller}}</div>
        <div style="margin-bottom: 4px;">日期: {{$utils.timeFn(printRow.schedulingTime, 'YYYY-MM-DD')}}</div>
        <div style="margin-bottom: 4px;">时间: {{printRow.startLineTime}}</div>
        <div style="margin-bottom: 4px;">车辆: {{printRow.licenseNo}}</div>
        <div style="margin-bottom: 4px;">票价: 
          {{ printRow.ticketFee }}元&nbsp;&nbsp;&nbsp;
          <span>
          {{ printRow.ticketFee - (printRow.stationChargeFee || 0) }}<span v-if="printRow.stationChargeFee">-{{ printRow.stationChargeFee }}</span>
          </span>
        </div>
        <div>乘客: {{ printRow.customerName }}({{ printRow.ticketType | filterConst('TICKETTYPE') }})</div>
        
      </div>
       <div style="width:50%;display: inline-block;text-align: right; vertical-align: top;">
        <div id="qrcode" style="width: 60px;height: 60px;"></div>
      </div>
     </div>
     <div style="font-size: 12px;margin-bottom: 4px;" v-if="printRow.idCard">{{printRow.cardType | fliterCardType('身份证号')}}: {{printRow.idCard.replace($const.CARDRULES[printRow.cardType || 1].defaultReg, $const.CARDRULES[printRow.cardType || 1].defaultReplace)}}</div>
  
     <!-- <div style="text-align: center;width: 100%;margin: 20px 0;">
       <div id="qrcode" style="width: 125px;height: 125px;margin-left: calc(73% - 125px)"></div>
     </div> -->
     <div style="border-width: 8px;border-bottom: 1px dashed #333333;height: 1px;margin: 4px 0;"></div>
     <div style="width: 100%;text-align: center;font-size: 12px;  margin-bottom: 10px;">如需获取电子发票，请关注“神都出行”微信公众号</div>
     <!-- page-break-after: always; -->
     <!-- <div style="width: 100%;text-align: center;font-size: 14px;">存根联</div>
     <div style="border-width: 8px;border-bottom: 1px dashed #333333;height: 1px;margin:2px 0;"></div>
     <div style="font-size: 12px;margin-bottom: 4px;">到达站点: {{ printRow.endStationName }}</div>
     <div style="font-size: 12px;margin-bottom: 4px;">电子票号: {{ printRow.ticketNo }}</div>
     <div style="font-size: 12px;margin-bottom: 4px;">售票车站: {{ printRow.organizationName }}</div>
     <div style="width: 100%;">
      <div style="width: 50%;font-size: 12px;display: inline-block;margin-bottom:4px;">发车日期: {{$utils.timeFn(printRow.schedulingTime, 'YYYY-MM-DD')}}</div>
      <div style="width: 50%;font-size: 12px;display: inline-block;margin-bottom:4px;">发车时间: {{printRow.startLineTime}}</div>
      <div style="width: 50%;font-size: 12px;display: inline-block;margin-bottom:4px;">车辆号牌码: {{printRow.licenseNo}}</div>
      <div style="width: 50%;font-size: 12px;display: inline-block;margin-bottom:4px;">车辆编号: {{printRow.vehicleNo}}</div>
      <div style="width: 50%;font-size: 12px;display: inline-block;margin-bottom:4px;">售票人员: {{printRow.ticketSeller}}</div>
      <div style="width: 50%;font-size: 12px;display: inline-block;margin-bottom:4px;">票价(元): 
        <span>
          {{ printRow.ticketFee - (printRow.stationChargeFee || 0) }}
          <span v-if="printRow.stationChargeFee">-{{ printRow.stationChargeFee }}</span>
        </span>
      </div>
     </div>
     <div style="border-width: 8px;border-bottom: 1px dashed #333333;height: 1px;margin: 2px 0;"></div>
     <div style="width: 100%;text-align: center;font-size: 12px">存根联仅提供给班线司机留存使用</div> -->
            <!-- <div style="padding-top: 92px;font-size:10px;display: inline-block;">
              <div style="margin-left:215px;height: 16px;">
                <span style="display: inline-block;width: 60px;vertical-align: top;">{{ printRow.startStationName }}</span>
                <span style="margin-left:10px;width: 60px;display: inline-block;vertical-align: top;">{{
                    printRow.endStationName
                  }}</span>
                <span style="margin-left:40px">{{ printRow.ticketFee }}</span>
              </div>
              <div style="margin:5px 0 0 30px">
                <span style="display: inline-block;width: 55px;vertical-align: top;text-align: right;">{{
                    printRow.endStationName
                  }}</span>
                <span style="margin-left:12px">{{ printRow.startLineTime }}</span>
                <span style="margin-left:12px">{{ printRow.licenseNo }}</span>
                <span style="margin-left:140px;;position: relative;top: 5px;">{{ printRow.ticketFee }}</span>
              </div>
              <div :style="{margin: printRow.endStationName.length>5? '10px 0 0 50px':'25px 0 0 50px'}">
                <span>{{ $utils.timeFn(Date.parse(new Date()), 'YYYY.MM.DD') }}</span>
                <span style="margin-left:10px;display: inline-block;min-width:20px;">
                  {{ printRow.ticketFee - (printRow.stationChargeFee || 0) }}
                  <span v-if="printRow.stationChargeFee">-{{ printRow.stationChargeFee }}</span>
                </span>
                <span style="margin-left:8px;display: inline-block;width:48px;vertical-align: top;">{{
                    printRow.ticketSeller
                  }}</span>
                <span style="margin-left:25px">{{ $utils.timeFn(printRow.schedulingTime, 'YYYY.MM.DD') }}</span>
                <span style="margin-left:35px">{{ printRow.startLineTime }}</span>
                <span style="margin-left:15px">{{ printRow.licenseNo }}</span>
                <span style="margin-left:15px">{{ printRow.seatNo }}</span>
              </div>
              <div style="margin:5px 0 0 0">
                <span style="margin-left: 100px"> {{ printRow.ticketType | filterConst('TICKETTYPE') }}</span>
                <span style="margin-left: 100px"><span v-if="printRow.idCard">{{
                    printRow.idCard && printRow.idCard.replace(/(.{10}).*(.{4})/, "$1****$2")
                  }}</span> </span>
                <span style="margin-left: 20px;">{{ printRow.customerName }}</span>
                <span style="margin-left: 10px"> {{ printRow.ticketType | filterConst('TICKETTYPE') }}</span>
              </div>
            </div> -->
    </div>

    <el-dialog :visible.sync="showDialog" title="票据打印" width="1000px" append-to-body
               :close-on-click-modal='false' :close-on-press-escape='false' @close="printListClose"
               style="margin-top: 140px;">
      <el-table :data="printList" v-loading="printListLoading" empty-text="暂无数据" border
                style="margin-bottom: 20px;">
        <el-table-column label="票号" prop="ticketNo" width="100"></el-table-column>
        <el-table-column label="线路" prop="startStationName" v-slot="{ row }">
          {{ row.startStationName + ' - ' + row.endStationName }}
        </el-table-column>
        <el-table-column label="票价" prop="ticketFee" width="60"></el-table-column>
        <el-table-column label="乘车日期" prop="schedulingTime" width="100" v-slot="{ row }">
          {{ row.schedulingTime | filterTime('YYYY-MM-DD') }}
        </el-table-column>
        <el-table-column label="开车时间" prop="startLineTime" width="70"></el-table-column>
        <el-table-column label="车次" prop="licenseNo" width="100"></el-table-column>
        <el-table-column label="乘客" prop="customerName" width="70" v-slot="{ row,$index }">
          <div v-if="printType">
            <el-button type="text" @click="clickUserUpdateFn(row,$index)" v-if="!row.printNum">
              {{ row.customerName }}
            </el-button>
            <span v-else>{{ row.customerName }}</span>
          </div>

          <span v-else>{{ row.customerName }}</span>
        </el-table-column>
        <el-table-column label="车票类型" prop="ticketType" width="70" v-slot="{ row }">
          {{ row.ticketType | filterConst('TICKETTYPE') }}
        </el-table-column>
        <el-table-column label="座号" prop="seatNo" width="50"></el-table-column>
        <el-table-column fixed="right" label="操作" width="80" v-slot="{ row,index }" align="center">

          <el-button  v-if="!row.printNum" type="text" size="small" @click="print(row,index)">
            {{ row.printNum ? '重新打印' : '打印' }}
          </el-button>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="showDialog2" title="添加实名信息" append-to-body
               :close-on-click-modal='false' :close-on-press-escape='false' width="450px">
      <el-form :model="loadData" :rules="rules" ref="form" label-position="left" label-width="100px">
        <el-form-item label="姓名" prop="customerName"
                      :rules="[{required: true, message: '请输入姓名', trigger: ['blur', 'change']}]">
          <div class="flex-start" style="width: 250px">
            <div>
              <el-input style="width: 200px" v-model="loadData.customerName" maxlength="10"/>
            </div>

            <el-button style="margin-left: 10px" type="text" @click="lookCardFn">
              读卡
            </el-button>
          </div>
        </el-form-item>

        <el-form-item label="身份证号码" prop="idCard" :rules="[{
                  pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                  message: '请输入正确的身份证号',
                  trigger: ['blur', 'change'],
                  required: true
                }]">
          <el-input style="width: 200px" v-model="loadData.idCard"
                    @input="loadData.idCard = loadData.idCard.replace(/[^\dXx]/g, '')"
                    maxlength="18"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialog2 = false">
          取消
        </el-button>
        <el-button type="primary" @click="updateSave">
          确认
        </el-button>
      </div>
    </el-dialog>


  </div>

</template>

<script>
import QRCode from "@/assets/js/qrcode.min";

export default {
  name: "printDialog",
  components: {

  },
  props: {
    value: {
      default: false
    },
    printListLoading: {
      default: false
    },
    list: {
      default: () => ([])
    }
  },
  data() {
    return {
      showDialog: false,
      printRow: {},
      printList: [],
      subIndex: 0,
      loadData: {},
      rules: {},
      showDialog2: false,
      printType: false,
      qrCode:null
    }
  },

  watch: {
    value: {
      handler() {
        this.showDialog = this.value
      },
      immediate: true
    },
    list: {
      handler() {
        this.printList = this.$utils.deepCopyFn(this.list)
        if (this.list && this.list.length) {
          this.printType = this.list[0].customerName.indexOf('乘客') !== -1
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    lookCardFn() {
      this.$emit('lookCardFn')
    },
    updateSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$set(this.printList, this.subIndex, {
            ...this.loadData
          })
          this.getUpdateCustomerInfo()

        } else {

          return false;
        }
      });
    },
    async getUpdateCustomerInfo() {
      const url = '/api/v1/manage/order/ticket/updateCustomerInfo'
      await this.$axios.post(url, this.loadData)
      this.showDialog2 = false
    },
    clickUserUpdateFn(row, index) {
      this.subIndex = index
      this.loadData = {
        ...row,
        customerName: row.customerName.indexOf('乘客') !== -1 ? '' : row.customerName,
      }
      this.showDialog2 = true
    },
    printListClose() {
      this.$emit('input', false)
      this.$emit('printListClose')
    },
    /* 打印发票 */
    print(row, index) {
      this.printRow = row;

      this.$set(this.printList, index, {...row, printNum: row.printNum++})
      //

      this.$nextTick(() => {
        const obj = {
          orderId: row.orderId,
          id:row.orderCustomerId
        }
        if (this.qrCode) {
          this.qrCode.makeCode(JSON.stringify(obj));
        } else {
          this.qrCode = new QRCode(document.getElementById("qrcode"), {
            text: JSON.stringify(obj),
            width: 125,
            height: 125,
          });
        }
        // setTimeout(()=>{
        //   const printContentHtml = document.getElementById("print").innerHTML;
        //   const iframe = document.createElement("iframe");
        //   document.body.appendChild(iframe);
        //   iframe.contentDocument.write(printContentHtml);
        //   iframe.contentDocument.close();
        //   iframe.contentWindow.print();
        //   setTimeout(() => {
        //     document.body.removeChild(iframe);
        //   }, 2000);
        // },100)
        setTimeout(() => {
          const printContentHtml = document.getElementById("print").innerHTML;
          const iframe = document.createElement("iframe");
          // 设置iframe的srcdoc属性，明确指定字符编码为UTF-8
          iframe.srcdoc = `<!DOCTYPE html><html><head><meta charset="UTF-8"></head><body>${printContentHtml}</body></html>`;
          document.body.appendChild(iframe);
          iframe.contentWindow.print();
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 2000);
        }, 100)
      })
    },
  }
}
</script>

<style scoped>
.print-header, .print-footer {
  display: none !important;
}
</style>